import { Stack, SvgIcon } from '@mui/material'
import { LeafIcon } from '@thriveglobal/thrive-web-leafkit'
import { AchievementIcons } from '../../../enums'
import useGetAchievementIcon from '../../../hooks/useGetAchievementIcon/useGetAchievementIcon'

export type AchievementIconProps = {
    achievementIcon?: AchievementIcons
    size?: 'small' | 'large'
}

const AchievementIcon: React.FC<AchievementIconProps> = ({
    achievementIcon,
    size = 'small'
}) => {
    const { color, icon, iconStyle } = useGetAchievementIcon(achievementIcon)
    const properties = {
        small: {
            svgWidth: 28,
            svgHeight: 32,
            leafIconSize: 16,
            viewBox: '0 0 28 32',
            polygonPath:
                'M12 1.1547C13.2376 0.440169 14.7624 0.440169 16 1.1547L25.8564 6.8453C27.094 7.55983 27.8564 8.88034 27.8564 10.3094V21.6906C27.8564 23.1197 27.094 24.4402 25.8564 25.1547L16 30.8453C14.7624 31.5598 13.2376 31.5598 12 30.8453L2.14359 25.1547C0.905989 24.4402 0.143594 23.1197 0.143594 21.6906V10.3094C0.143594 8.88034 0.905989 7.55983 2.14359 6.8453L12 1.1547Z'
        },
        large: {
            svgWidth: 64,
            svgHeight: 70,
            leafIconSize: 32,
            viewBox: '0 0 64 70',
            polygonPath:
                'M28 1.3094C30.4752 -0.119661 33.5248 -0.119661 36 1.3094L59.1769 14.6906C61.6521 16.1197 63.1769 18.7607 63.1769 21.6188V48.3812C63.1769 51.2393 61.6521 53.8803 59.1769 55.3094L36 68.6906C33.5248 70.1197 30.4752 70.1197 28 68.6906L4.82308 55.3094C2.34788 53.8803 0.823086 51.2393 0.823086 48.3812V21.6188C0.823086 18.7607 2.34788 16.1197 4.82309 14.6906L28 1.3094Z'
        }
    }

    const { svgWidth, svgHeight, leafIconSize, viewBox, polygonPath } =
        properties[size]

    return (
        <Stack position="relative" width={svgWidth} height={svgHeight}>
            <SvgIcon
                fill="none"
                width={svgWidth}
                height={svgHeight}
                viewBox={viewBox}
                xmlns="http://www.w3.org/2000/svg"
                sx={{ height: svgHeight, width: svgWidth }}
            >
                <path d={polygonPath} fill={color} />
            </SvgIcon>
            <Stack
                position="absolute"
                top="50%"
                left="50%"
                sx={{
                    transform: 'translate(-50%, -50%)',
                    width: 'fit-content',
                    height: 'fit-content'
                }}
            >
                <LeafIcon
                    icon={icon}
                    iconStyle={iconStyle}
                    color="info"
                    sx={{ height: leafIconSize, width: leafIconSize }}
                />
            </Stack>
        </Stack>
    )
}

export default AchievementIcon
